/*
 * Playground registry — interactive experiments & playable prototypes.
 * Add a new entry here and a matching component in COMPONENTS (PlaygroundDetail)
 * to grow the section. Everything runs client-side (static-host friendly).
 */
export const EXPERIMENTS = [
  {
    slug: "flow-field",
    title: "Drift",
    kind: "Generative · Interactive",
    year: "2026",
    blurb:
      "A real-time flow field of particles that bends around your cursor. Move the pointer (or touch) to steer the current.",
    tags: ["Canvas", "Generative", "Motion"],
  },
  {
    slug: "2048",
    title: "Twenty Forty-Eight",
    kind: "Game · Playable",
    year: "2026",
    blurb:
      "The classic sliding-tile puzzle, rebuilt in the site's type and palette. Use arrow keys, swipe, or the on-screen pad.",
    tags: ["Game", "Logic", "Keyboard · Touch"],
  },
];

export const getExperiment = (slug) =>
  EXPERIMENTS.find((e) => e.slug === slug) || null;
